(function () {
  'use strict';

  function initialiseMainCart(section) {
    if (!section) return;

  const cartForm = section.querySelector('[data-cart-page-form]');
  const itemsContainer = section.querySelector('[data-cart-page-items]');
  const subtotal = section.querySelector('[data-cart-page-subtotal]');
  const count = section.querySelector('[data-cart-page-count]');
  const discounts = section.querySelector('[data-cart-page-discounts]');
  const gifting = section.querySelector('[data-cart-gifting]');
  const giftWrapToggle = section.querySelector('[data-gift-wrap-toggle]');
  const giftMessageWrap = section.querySelector(
    '[data-gift-message-wrap]'
  );
  const giftMessage = section.querySelector('[data-gift-message]');
  const giftMessageCount = section.querySelector(
    '[data-gift-message-count]'
  );
  const giftStatus = section.querySelector('[data-gift-status]');
  const orderNote = section.querySelector('[data-cart-order-note]');
  const orderNoteStatus = section.querySelector(
    '[data-cart-order-note-status]'
  );
  const orderNoteCount = section.querySelector(
    '[data-cart-order-note-count]'
  );

  const giftStatusRenderer = window.CartController.createStatusRenderer({
    element: giftStatus
  });

  const giftWrapVariantId = Number(
    section.dataset.giftWrapVariantId || 0
  );

  let giftWrapKey = section.dataset.giftWrapKey || '';

  const giftMessageField = window.CartController.createAutosaveField({
    delay: 500,
    maximum: 300,
    getCount() {
      return giftMessageCount;
    },
    onInput() {
      updateGiftMessageVisibility();
    },
    onSave() {
      return saveGiftOptions({ updateProduct: false });
    }
  });

  const orderNoteField = window.CartController.createAutosaveField({
    delay: 500,
    getCount() {
      return orderNoteCount;
    },
    onSave() {
      return saveOrderNote();
    }
  });

  if (!cartForm || !itemsContainer) return;

    if (section.dataset.mainCartInitialised === 'true') return;
    section.dataset.mainCartInitialised = 'true';

  let activeLineRequests = 0;

  const requestStatus = window.CartController.createStatusRenderer({
    before: itemsContainer,
    className: 'main-cart__request-status',
    role: 'alert',
    live: 'assertive'
  });

  const formatMoney = window.CartUI.formatMoney.bind(window.CartUI);

  function getItem(key) {
    return section.querySelector(
      `[data-cart-page-item][data-key="${CSS.escape(key)}"]`
    );
  }

  function renderCartDiscounts(cart) {
    if (!discounts) return;

    const applications =
      cart.cart_level_discount_applications || [];

    if (!applications.length) {
      discounts.innerHTML = '';
      discounts.hidden = true;
      return;
    }

    discounts.innerHTML = applications
      .map(function (application) {
        return `
          <li>
            <span>${escapeHtml(application.title)}</span>
            <strong>
              −${formatMoney(application.total_allocated_amount)}
            </strong>
          </li>
        `;
      })
      .join('');

    discounts.hidden = false;
  }

  const escapeHtml = window.CartUI.escapeHtml.bind(window.CartUI);

  function dispatchCartUpdate(cart, source) {
    window.CartUI.dispatchUpdated(cart, source || 'cart-page');
  }

  async function updateLine(key, quantity, context) {
    if (!key) return;

    requestStatus.clear();

    const item = getItem(key);

    if (!item) return;

    const quantityInput = item.querySelector('[data-cart-page-quantity]');
    const lineState = window.CartController.createLineState({
      scopePrefix: 'main-cart-line',
      key,
      quantityInput,
      busyTarget: item,
      busyOptions: { className: 'is-loading' }
    });

    activeLineRequests += 1;
    lineState.setLoading(true);
    itemsContainer.setAttribute('aria-busy', 'true');

    try {
      const line = Number(context?.line || item.dataset.line || 0);
      const cart = line
        ? await window.CartApi.changeLine(line, quantity)
        : await window.CartApi.change(key, quantity);

      if (
        !lineState.isLatest()
      ) {
        return;
      }

      if (subtotal) {
        subtotal.textContent = formatMoney(cart.total_price);
      }

      if (count) {
        count.textContent = cart.item_count;
      }

      renderCartDiscounts(cart);
      dispatchCartUpdate(cart, 'cart-page:line-change');

      const updatedItem = line ? cart.items[line - 1] : null;

      if (!updatedItem || quantity === 0) {
        window.location.reload();
        return;
      } else {
        const linePrice = item.querySelector(
          '[data-cart-page-line-price]'
        );

        if (quantityInput) {
          lineState.confirm(updatedItem.quantity);
        }

        if (linePrice) {
          linePrice.textContent = formatMoney(
            updatedItem.final_line_price
          );
        }
      }

      if (cart.item_count === 0) {
        window.location.reload();
      }
    } catch (error) {
      if (
        !lineState.isLatest()
      ) {
        return;
      }

      console.error(error);

      lineState.rollback();

      requestStatus.error(
        error,
        'We could not update your basket. Please try again.'
      );
    } finally {
      activeLineRequests = Math.max(0, activeLineRequests - 1);

      if (
        lineState.isLatest()
      ) {
        lineState.setLoading(false);
      }

      itemsContainer.setAttribute(
        'aria-busy',
        String(activeLineRequests > 0)
      );
    }
  }

  function updateGiftMessageVisibility() {
    if (!giftMessageWrap || !giftWrapToggle) return;

    const hasMessage = Boolean(giftMessage?.value.trim());

    giftMessageWrap.hidden =
      !giftWrapToggle.checked && !hasMessage;
  }

  async function addGiftWrap() {
    return window.CartServices.addGiftWrap(giftWrapVariantId);
  }

  async function removeGiftWrap() {
    return window.CartServices.removeGiftWrap(
      giftWrapVariantId,
      giftWrapKey
    );
  }

  async function saveGiftAttributes() {
    return window.CartServices.saveGiftAttributes(
      Boolean(giftWrapToggle?.checked),
      giftMessage?.value || ''
    );
  }

  async function saveGiftOptions(options) {
    if (!gifting) return;

    const updateProduct = options?.updateProduct === true;
    const shouldAddGiftWrap = Boolean(giftWrapToggle?.checked);

    gifting.classList.add('is-saving');

    if (giftWrapToggle) {
      giftWrapToggle.disabled = true;
    }

    if (giftStatus) giftStatusRenderer.saving();

    try {
      let cart;

      if (updateProduct) {
        cart = shouldAddGiftWrap
          ? await addGiftWrap()
          : await removeGiftWrap();

        const matchingItem = cart.items.find(function (item) {
          return Number(item.variant_id) === giftWrapVariantId;
        });

        giftWrapKey = matchingItem?.key || '';
      }

      cart = await saveGiftAttributes();

      if (subtotal) {
        subtotal.textContent = formatMoney(cart.total_price);
      }

      if (count) {
        count.textContent = cart.item_count;
      }

      renderCartDiscounts(cart);
      dispatchCartUpdate(cart);

      if (giftStatus) {
        giftStatusRenderer.success(
          updateProduct
            ? shouldAddGiftWrap
              ? 'Gift wrapping added'
              : 'Gift wrapping removed'
            : 'Gift message saved',
          updateProduct ? 0 : 1800
        );
      }

      /*
       * Reload because adding/removing gift wrapping changes the cart's
       * line ordering and the list of displayed products.
       */
      if (updateProduct) {
        window.location.reload();
        return;
      }


    } catch (error) {
      console.error(error);

      if (updateProduct && giftWrapToggle) {
        giftWrapToggle.checked = !shouldAddGiftWrap;
        updateGiftMessageVisibility();
      }

      if (giftStatus) {
        giftStatusRenderer.error(
          error,
          'Gift options could not be saved. Please try again.'
        );
      }
    } finally {
      gifting.classList.remove('is-saving');

      if (giftWrapToggle) {
        giftWrapToggle.disabled = false;
      }
    }
  }

  async function saveOrderNote() {
    if (!orderNote) return;

    try {
      await window.CartController.saveOrderNote({
        textarea: orderNote,
        status: orderNoteStatus,
        source: 'cart-page:note'
      });
    } catch (error) {
      // The shared controller has already rendered the error state.
    }
  }

  window.CartController.createLineControls({
    root: section,
    minusSelector: '[data-cart-page-minus]',
    plusSelector: '[data-cart-page-plus]',
    removeSelector: '[data-cart-page-remove]',
    quantitySelector: '[data-cart-page-quantity]',
    getInput(key, trigger) {
      const line = Number(trigger?.dataset.line || 0);

      if (line) {
        return section.querySelector(
          `[data-cart-page-quantity][data-line="${line}"]`
        );
      }

      return section.querySelector(
        `[data-cart-page-quantity][data-key="${CSS.escape(key)}"]`
      );
    },
    onChange(key, quantity, context) {
      updateLine(key, quantity, context);
    }
  });

  giftWrapToggle?.addEventListener('change', function () {
    updateGiftMessageVisibility();

    saveGiftOptions({
      updateProduct: true
    });

    if (giftWrapToggle.checked) {
      window.setTimeout(function () {
        giftMessage?.focus();
      }, 50);
    }
  });

  giftMessage?.addEventListener('input', function () {
    giftMessageField.handleInput(giftMessage);
  });

  orderNote?.addEventListener('input', function () {
    orderNoteField.handleInput(orderNote);
  });

  updateGiftMessageVisibility();
  giftMessageField.initialise(giftMessage);
  orderNoteField.initialise(orderNote);
  }

  function initialiseAllMainCarts(root) {
    const scope = root || document;

    if (scope.matches?.('[data-main-cart]')) {
      initialiseMainCart(scope);
      return;
    }

    scope
      .querySelectorAll?.('[data-main-cart]')
      .forEach(initialiseMainCart);
  }

  if (!window.TreesDirectMainCart) {
    window.TreesDirectMainCart = {
      initialise: initialiseMainCart,
      initialiseAll: initialiseAllMainCarts
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initialiseAllMainCarts(document);
      }, { once: true });
    } else {
      initialiseAllMainCarts(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initialiseAllMainCarts(event.target);
    });
  } else {
    window.TreesDirectMainCart.initialiseAll(document);
  }
})();
